import { Box, H4, P, ColorPreset } from "@gocardless/flux-react";

interface Props {
  title: string;
  description?: JSX.Element | string;
}

const SectionHeader: React.FC<Props> = ({ title, description }) => (
  <Box>
    <H4 color={ColorPreset.TextOnLight_01} spaceBelow={description ? 1 : 0}>
      {title}
    </H4>
    {description && <P color={ColorPreset.TextOnLight_02}>{description}</P>}
  </Box>
);

export default SectionHeader;
